import type { CSSProperties } from 'react';
import { useScrollProgress } from '../motion/useScrollProgress';

type MediaFigureProps = {
  src: string;
  srcSmall?: string;
  alt: string;
  title: string;
  caption: string;
  /** object-position for the crop — lets one wide render art-direct several sections. */
  focus?: string;
  height?: number;
  className?: string;
};

/** An image block whose picture drifts against the page scroll, so it sits in depth rather than flat on the page. */
export function MediaFigure({ src, srcSmall, alt, title, caption, focus = '50% 50%', height = 340, className = '' }: MediaFigureProps) {
  const ref = useScrollProgress<HTMLElement>();

  return (
    <figure ref={ref} className={`media-figure reveal ${className}`} style={{ height } as CSSProperties}>
      <picture>
        {srcSmall && <source srcSet={srcSmall} media="(max-width: 720px)" />}
        <img src={src} alt={alt} style={{ objectPosition: focus }} loading="lazy" decoding="async" />
      </picture>
      <figcaption>
        <strong>{title}</strong>
        <span>{caption}</span>
      </figcaption>
    </figure>
  );
}
